import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    public Server = 'https://intldirectory.iowaeda.com/'; // use this for prod api's for resource directories
    //public Server = 'http://localhost:63756/';
}
